import { GreetingsIcon } from './greetings-icon';
import { GreetingsTitle } from './greetings-title';
import { useGreetingsScope } from './hooks';

export type GreetingsScope = 'afternoon' | 'evening' | 'morning';

type P = {
  isCollapsed: boolean;
};

const Greetings = ({ isCollapsed }: P) => {
  const scope = useGreetingsScope();

  return (
    <div className="greetings">
      <GreetingsIcon className="greetings__image" scope={scope} />
      {isCollapsed ? null : <GreetingsTitle className="greetings__title" scope={scope} />}
    </div>
  );
};

export default Greetings;
